import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ApplicationsApi } from '@element451-libs/api451';
import { SerializablePage451Component } from '@element451-libs/page451-lib';
import { compareDescending } from '@element451-libs/utils451/dates';
import { sortCollection } from '@element451-libs/utils451/helpers';
import { map } from 'rxjs/operators';
import { AccountService, StartApplication, UserData } from '../../../+state';
import { ApplicationListService } from '../../services';

type SortableProps = Pick<ApplicationsApi.UserApplication, 'registered_at'>;

@Component({
  selector: 'elm-app-applications-panel',
  templateUrl: './applications-panel.component.html',
  styleUrls: ['./applications-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationsPanelComponent {
  @Input() row: SerializablePage451Component;

  loading$ = this.applicationList.loading$;

  loaded$ = this.applicationList.loaded$;

  list$ = this.applicationList.list$.pipe(
    map(applications => sortApplications(applications))
  );

  hasApplications$ = this.list$.pipe(map(apps => apps.length > 0));

  firstName$ = this.userData.userPropertiesFromData$.pipe(
    map(data => data.first_name)
  );

  applicationRegistrationErrorMessage$ =
    this.accountService.applicationRegistrationErrorMessage$;

  constructor(
    private startApplication: StartApplication,
    private applicationList: ApplicationListService,
    private userData: UserData,
    private accountService: AccountService
  ) {}

  trackByApplication(
    index: number,
    application: ApplicationsApi.UserApplication
  ) {
    return application.guid;
  }

  onStartApplication() {
    this.startApplication.openStartApplicationDialog();
  }
}

export const sortHandler = (a: SortableProps, b: SortableProps) => {
  return compareDescending(a.registered_at, b.registered_at);
};

const sortApplications = sortCollection(sortHandler);
